import { ButtonSet, Form, Loading } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import http from "../../http-common";
import Card from "../../components/Card/Card";
import useAuth from "../../hooks/useAuth";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import PersonalDataForm from "../../components/Forms/PersonalDataForm";
import TrainingAreaForm from "../../components/Forms/TrainingAreaForm";
import useCandidature from "../../hooks/useCandidature";
import { checkHasOwnBusiness, checkIsEmployed } from "../../services/Utils";
import AvailabilityForm from "../../components/Forms/AvailabilityForm";
import BusinessDetailsForm from "../../components/Forms/BusinessDetailsForm";
import { yupResolver } from "@hookform/resolvers/yup";
import { basicCandidatureSchema } from "../../services/SchemaService";
import ApplicationDisclaimer from "../../components/Miscellaneous/ApplicationDisclaimer";

const UpdateCandidaturePage = () => {
  const { state } = useLocation();
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { isLoading, candidature } = useCandidature(uuid);
  // const [candidature, setCandidature] = useState(state.candidature);
  const [activeTab, setActiveTab] = useState(0);
  const [isOpen, setIsOpen] = useState(true);
  const [selectedOccupations, setSelectedOccupations] = useState([]);
  const [selectedBusinessPhases, setSelectedBusinessPhases] = useState([]);
  const [selectedBusinessSectors, setSelectedBusinessSectors] = useState([]);
  const [selectedWorkAreas, setSelectedWorkAreas] = useState([]);
  const [selectedTrainingProviders, setSelectedTrainingProviders] = useState(
    []
  );
  const [selectedTrainingAreas, setSelectedTrainingAreas] = useState([]);
  const [hasOwnBusiness, setHasOwnBusiness] = useState(false);
  const [isEmployed, setIsEmployed] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(basicCandidatureSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      data.businessPhases = selectedBusinessPhases;
      data.businessSectors = selectedBusinessSectors;
      data.workAreas = selectedWorkAreas;
      data.pastTrainings = selectedTrainingProviders;
      data.trainingPreferences = selectedTrainingAreas;
      const response = await http.put("/applications", data);
      toast.success("Candidatura Actualizada com sucesso");
      navigate("../candidature/" + response.data);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    reset(candidature);
    setSelectedBusinessPhases(candidature.businessPhases);
    setSelectedWorkAreas(candidature.workAreas);
    setSelectedTrainingProviders(candidature.pastTrainings);
    setSelectedTrainingAreas(candidature.trainingPreferences);
    setIsOpen(candidature.currentStageCode === 1);
  }, [candidature]);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Editar Candidatura">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="Declaração">
            <ApplicationDisclaimer />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-0" label="Dados Pessoais">
            <PersonalDataForm
              reset={reset}
              register={register}
              control={control}
              errors={errors}
              candidature={candidature}
              hasOwnBusiness={true}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>

          {!hasOwnBusiness && (
            <Tab href="#" id="tab-3" label="Negócio">
              <BusinessDetailsForm
                register={register}
                control={control}
                errors={errors}
                selectedBusinessPhases={selectedBusinessPhases}
                setSelectedBusinessPhases={setSelectedBusinessPhases}
                selectedWorkAreas={selectedWorkAreas}
                setSelectedWorkAreas={setSelectedWorkAreas}
                candidature={candidature}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>
          )}

          <Tab href="#" id="tab-6" label="Capacitação">
            <TrainingAreaForm
              register={register}
              errors={errors}
              selectedTrainingProviders={selectedTrainingProviders}
              setSelectedTrainingProviders={setSelectedTrainingProviders}
              selectedTrainingAreas={selectedTrainingAreas}
              setSelectedTrainingAreas={setSelectedTrainingAreas}
              candidature={candidature}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
            </div>
          </Tab>
        </Tabs>
        <ButtonSet>
          <SubmitButton className={"emprega-bg-green"} />
          <CancelButton />
        </ButtonSet>
      </Form>
    </Card>
  );
};

export default UpdateCandidaturePage;
